import script from "./VoidMonthlyPaymentModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./VoidMonthlyPaymentModal.vue?vue&type=script&setup=true&lang=ts"

import "./VoidMonthlyPaymentModal.vue?vue&type=style&index=0&id=5d435765&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d435765"]])

export default __exports__